const buildViewUrl = (params = {}, rootUrl = null) => {
    if (!rootUrl) rootUrl = 'PromoHubView';
    const query = new URLSearchParams(params).toString();
    return `${rootUrl}${query ? `?${query}` : ''}`;
};

const Enum = {
    FRONT_END_URL: Object.freeze({
        MARKET_PAGE: '#/pagina_mercado/',
        POINTS_HISTORY: '#/pointsHistory',
        POINTS_GAME: '#/pointsGame',
        MAINTENANCE: '#/maintence',
    }),
    API: {
        MarketReviews: Object.freeze({
            OP_STATS: 'OP_STATS',
            OP_USER_REVIEW: 'OP_USER_REVIEW',
            OP_USERS_REVIEWS: 'OP_USERS_REVIEWS',
        }),
        User: Object.freeze({
            cpf: 'cpf',
            nome: 'nome',
            data_criacao: 'data_criacao',
            hora_criacao: 'hora_criacao',
            status: 'status',
            id_local: 'id_local',
            email: 'email',
            telefone: 'telefone',
            telefone: 'telefone',
            notify_mural: 'notify_mural',
            notify_encarte: 'notify_encarte',
            notify_minha_lista: 'notify_minha_lista',
            notify_email: 'notify_email',
            notify_sorteio_realizado: 'notify_sorteio_realizado',
            total_pontos: 'total_pontos',
            check_in: 'check_in',
            data_last_check_in: 'data_last_check_in',
            meu_codigo_indicacao: 'meu_codigo_indicacao',
            codigo_indicacao_amigo: 'codigo_indicacao_amigo',
            eh_conta_google: 'eh_conta_google',
            data_primeira_infracao_do_mes: 'data_primeira_infracao_do_mes',
            qtd_infracoes_do_mes: 'qtd_infracoes_do_mes',
            qtd_acusacoes_invalidas_do_mes: 'qtd_acusacoes_invalidas_do_mes',
            data_time_ultima_infracao: 'data_time_ultima_infracao',
            data_time_ultima_infracao: 'data_time_ultima_infracao',
            local: 'local',
            foto_perfil: 'foto_perfil',
            smart_list: 'smart_list',
        }),
        UserExtras: Object.freeze({
            meus_indicados: 'meus_indicados',
            is_adm: 'is_adm',
        }),

        Mail: Object.freeze({
            codeType: Object.freeze({//nunca mudar de ordem, pois usa indexOF
                CONFIRM_ACCOUNT: 'CONFIRM_ACCOUNT',
                DELETE_ACCOUNT: 'DELETE_ACCOUNT',
            }),
            codeTypeToText: Object.freeze({//nunca mudar de ordem, pois usa indexOF
                CONFIRM_ACCOUNT: 'Confirmar conta',
                DELETE_ACCOUNT: 'Deletar conta',
            }),
        }),

        Points: Object.freeze({
            PriceType: Object.freeze({//nunca mudar de ordem, pois usa indexOF
                PROMOHUB_SINGLE_REQUEST: 'PROMOHUB_SINGLE_REQUEST',
                PROMOHUB_MONITOR_REQUEST: 'PROMOHUB_MONITOR_REQUEST',

                PROMOHUB_UPDATE_REQUEST: 'PROMOHUB_UPDATE_REQUEST',
            }),
            Key: Object.freeze({//nunca mudar de ordem, pois usa indexOF
                JOGO_ORACIO_RECICLA: 'JOGO_ORACIO_RECICLA',
                JOGO_PEGA_PRECO: 'JOGO_PEGA_PRECO',
                APP_CHECK_IN: 'APP_CHECK_IN',

                //apenas readonly
                PROMOHUB_MURAL_POST: 'PROMOHUB_MURAL_POST',
                USE_OF_MY_REFERRAL_CODE: 'USE_OF_MY_REFERRAL_CODE',
                //
            }),
            HumanKey: Object.freeze({//nunca mudar de ordem, pois usa indexOF
                REVIEW_IN_APP_STORE: 'REVIEW_IN_APP_STORE',
            }),
        }),

        Local: Object.freeze({
            id_local: 'id_local',
            nome_cidade: 'nome_cidade',
            latitude: 'latitude',
            longitude: 'longitude',
            raio_cidade_km: 'raio_cidade_km',
            nome_estado: 'nome_estado',
            sigla: 'sigla',
            local_compacto: 'local_compacto',
        }),

        PromoHub: Object.freeze({
            TYPE: Object.freeze({
                MURAL: 'MURAL',
                BARCODE: 'BARCODE',

                BARCODE_RADAR: 'BARCODE_RADAR'
            }),
            FILTER: Object.freeze({
                RECENT: 'RECENT',
                RELEVANCE: 'RELEVANCE',
                FAVORITE: 'FAVORITE',
                MARKET: 'MARKET',
                MY: 'MY',
                TRUSTED_RECENT: 'TRUSTED_RECENT'
            }),
            ACTIONS: Object.freeze({
                THUMBS_UP: 'THUMBS_UP',
                FAVORITE: 'FAVORITE',
                COMMENTS: 'COMMENTS',
            }),
            VIEW_URL: Object.freeze({
                ROOT: buildViewUrl(),
                FAVORITE: buildViewUrl({ hubType: 'MURAL', isFavorite: 1 }),
                MY_POSTS: buildViewUrl({ hubType: 'MURAL', isMy: 1 }),
                MARKET_PAGE: (localId, marketId, marketName) => {
                    return buildViewUrl({
                        hubType: 'MURAL',
                        marketId,
                        marketName,
                        hiddenComments: 1,
                        showHubs: 0,
                        localId,
                    }, Enum.FRONT_END_URL.MARKET_PAGE)
                },
                SHARED: (hubType, filterQuery, localId, hiddenComments = 0, showHubs = 0) => {
                    return buildViewUrl({
                        hubType,
                        filterQuery,
                        localId,
                        hiddenComments,
                        showHubs,
                    })
                },
                SMART_LIST: (hubType, filterQuery, migrateTypeHub = 0) => {
                    return buildViewUrl({
                        hubType,
                        filterQuery,
                        hiddenComments: 1,
                        showHubs: 1,
                        isTrustedRecent: 1,
                        hiddenFilters: 1,
                        migrateTypeHub,
                    })
                },
                ENCARTE: (city_id, encarte_id) => {
                    return buildViewUrl({
                        city_id,
                        encarte_id
                    }, 'encartes')
                },
            }),
        }),

        MAPS: Object.freeze({
            TYPE: Object.freeze({
                MARKET: 'MARKET',
            }),
            ResponseFields: Object.freeze({
                id: 'id',
                localId: 'localId',
                title: 'title',
                radius: 'radius',
                lat: 'lat',
                lng: 'lng',
                notices: 'notices',
                icon: 'icon',
                numberOfPosts: 'numberOfPosts',
                total_avaliacoes: 'total_avaliacoes',
                media_avaliacoes: 'media_avaliacoes',
            }),
        }),

        API_STATUS_CODE: Object.freeze({
            200: 200,
        }),

        CDN: Object.freeze({
            URL: Object.freeze({
                MARKET_ICON: '/cdn/market/icon/',
                MARKET_ENCARTE: '/cdn/market/encarte/',

                PROMOHUB_IMG: '/cdn/promoHub/img/',

                PRODUCTS_IMG: '/cdn/products/img/',

                HOME_BANNER: '/cdn/homeBanners/bannerList/',

                ADS_GET: '/cdn/ads/get/',

                //conteúdo do aplicativo
                APP: '/cdn/public/app/',
                QR_CODE: '/cdn/public/qrCode/',
                MAPS_V2: '/cdn/public/mapsV2/',
                GOOGLE_OAUTH: '/cdn/public/google_oauth/',
                MARKET_BANNER: '/cdn/public/market/banner/',

                USER_PHOTO: '/cdn/user/photo/',
            }),
            EXTENSION: Object.freeze({

                MARKET_ICON: '.png',
                MARKET_ENCARTE: '.webp',

                PROMOHUB_IMG: '.webp',

                HOME_BANNER: '.avif',

                ADS_GET: '.png',

                USER_PHOTO: '.webp',
            }),
        }),
    },

    MAPS: {
        MESSAGE: Object.freeze({
            ON_LOAD: 'Enum.MAPS.MESSAGE.ON_LOAD',
            ON_CLICK: 'Enum.MAPS.MESSAGE.ON_CLICK',
            ON_CLICK_IN_MARKER: 'Enum.MAPS.MESSAGE.ON_CLICK_IN_MARKER',

            ADD_MARKER: 'Enum.MAPS.MESSAGE.ADD_MARKER',
            LOOK_AT: 'Enum.MAPS.MESSAGE.LOOK_AT',

            FILTER_MARKER: 'Enum.MAPS.MESSAGE.FILTER_MARKER',
            FILTER_MARKER_AMOUNT: 'Enum.MAPS.MESSAGE.FILTER_MARKER_AMOUNT',

            MARKER_ADD_NOTICE: 'Enum.MAPS.MESSAGE.MARKER_ADD_NOTICE',
            MARKER_NOTIFY: 'Enum.MAPS.MESSAGE.MARKER_NOTIFY',

            SET_USER_POSITION: 'Enum.MAPS.MESSAGE.SET_USER_POSITION',
        }),
    },

    SSE_SERVICE: {
        EVENT: Object.freeze({
            ON_RECEIVE_SERVER_MESSAGE: 'Enum.SSE_SERVICE.EVENT.ON_RECEIVE_SERVER_MESSAGE',
        }),
        SERVICE: Object.freeze({
            SSE_PROMO_HUB_NEW_POST: 'SSE_PROMO_HUB_NEW_POST',
            SSE_USER_SMART_LIST_UPDATE: 'SSE_USER_SMART_LIST_UPDATE',
            SSE_MAINTENANCE: 'SSE_MAINTENANCE',
        }),
    }
}

module.exports = {
    Enum
}